import React from "react";
import useStep from "Utils/MultiStep/useStep";
import useForm from "Utils/MultiStep/useForm";

import AddressFields from "Pages/Enrollment/FieldGroups/AddressFields";
import BankAccountFields from "Pages/Enrollment/FieldGroups/BankAccountFields";
import GeneralInfoFields from "Pages/Enrollment/FieldGroups/GeneralInfoFields";
import IdentificationFields from "Pages/Enrollment/FieldGroups/IdentificationFields";
import EnrollmentStep from "./EnrollmentStep";

const MultiStepForm = ({ fromOperator, defaultData, submit, errorMessage, isEnrollment, plaidRedirect }) => {
  const steps = Object.keys(fromOperator).map((key) => ({ id: key }));

  const { step, navigation, index } = useStep({ key: steps.length, steps: steps });
  const { id } = step;

  const liWidth = Math.floor(100 / steps.length);
  const liStyle = { width: liWidth + "%" };

  const [formData, setForm] = useForm(defaultData);
  const props = { formData, setForm, fromOperator, errorMessage, isEnrollment, plaidRedirect };
  const navProps = { steps, navigation, index, submit };

  let title;

  const renderFields = (function (id) {
    switch (id) {
      case "general":
        title = 'General Info';
        return (fieldProps) => <GeneralInfoFields {...fieldProps} />;
      case "id":
        title = 'Identification Info'
        return (fieldProps) => <IdentificationFields {...fieldProps} />;
      case "address":
        title = 'Address Info';
        return (fieldProps) => <AddressFields {...fieldProps} />;
      case "bank":
        title = 'Add Funding Source';
        return (fieldProps) => <BankAccountFields {...fieldProps} />;
      default:
        title = 'Enrollment';
        return () => <div className="top-error">Unknown Enrollment Page</div>;
    }
  })(id);

  const pageProps = { ...props, renderFields, navProps };

  return (
    <div>
      {/* Setting 'key' causes react to re-render the entire page when step changes
          Which clears out local form state. This is desired behavior for now... */}
      <EnrollmentStep {...pageProps} key={id} title={title} />
      {/* <div className="form-row">
        <div className="col-md-10 offset-md-1 col-12">
          <ul id="progressbar">
            {steps.length > 1
              ? steps.map((step, i) => {
                return (
                  <li
                    style={liStyle}
                    className={i <= index ? "active" : ""}
                    id={step.id}
                    key={step.id}
                  ></li>
                );
              })
              : ""}
          </ul>
        </div>
      </div> */}
    </div>
  );
};

export default MultiStepForm;
